export default __webpack_public_path__ + "static/media/applications.c423fb05.svg";